import React, { useEffect, useRef, useState } from "react";

const HeaderColorPicker = ({
  onChange,
  defaultText,
  defaultHex = [0, 0, 0],
}) => {
  const rgbArrayToHex = (rgb) => {
    return (
      "#" +
      rgb
        .map((val) => {
          const hex = val.toString(16);
          return hex.length === 1 ? "0" + hex : hex;
        })
        .join("")
    );
  };

  const hexToRgbArray = (hex) => {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return [r, g, b];
  };

  // 🧠 Store the *original* defaultHex in a ref so it never changes
  const initialDefaultRef = useRef(defaultHex);

  const [colorHex, setColorHex] = useState(rgbArrayToHex(defaultHex));

  useEffect(() => {
    setColorHex(rgbArrayToHex(defaultHex));
  }, [defaultHex]);

  const handleColorChange = (e) => {
    const hex = e.target.value;
    setColorHex(hex);
    const rgbArray = hexToRgbArray(hex);
    onChange && onChange(rgbArray);
  };

  const handleReset = () => {
    const defaultColor = initialDefaultRef.current;
    const hex = rgbArrayToHex(defaultColor);
    setColorHex(hex);
    onChange && onChange(defaultColor);
  };

  return (
    <div className="flex flex-col">
      <span className="text-sm font-medium">{defaultText}</span>
      <div className="flex items-center space-x-3 mt-2">
        <label className="text-sm font-medium">Selected Color:</label>
        <input
          type="color"
          value={colorHex}
          onChange={handleColorChange}
          className="w-8 h-8 p-0 border border-gray-300 dark:border-gray-600 rounded"
        />
        <button
          type="button"
          onClick={handleReset}
          className="ml-4 px-3 py-1 text-sm text-white border rounded hover:bg-gray-400/50 transition-colors"
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default HeaderColorPicker;
